// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-dialog-container {
  padding: 0 !important;
  overflow: hidden;
}

h1.mat-dialog-title {
  padding: 20px 24px 16px 24px;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  text-align: center;
}

.mat-dialog-content {
  padding: 24px;
  font-size: 12px;
  color: #333;
  max-height: 60vh;
  overflow-y: auto;
}

.mat-dialog-actions {
  padding: 16px 24px;
  margin: 0;
  border-top: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.Btn_confirm {
  min-width: 80px;
  padding: 6px 16px;
  font-size: 12px;
  border: 1px solid rgba(120, 130, 140, 0.13);
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  transition: all 0.2s ease;
}

.Btn_confirm:focus {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid rgba(120, 130, 140, 0.2) !important;
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.Btn_confirm:hover {
  background-color: #f8f9fa !important;
  color: rgba(0, 0, 0, 0.87) !important;
  border: 1px solid rgba(120, 130, 140, 0.2) !important;
  box-shadow: inset 0 -10rem 0px rgba(158, 158, 158, 0.2);
}

.badge-success {
  background-color: #5cb85c;
  color: #fff;
}

.badge-danger {
  background-color: #d9534f;
  color: #fff;
}

.badge-warning {
  background-color: #f0ad4e;
  color: #fff;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/save-all-confirmation-dialog/save-all-confirmation-dialog.component.scss","webpack://./../../../Git%20space/admin/standalone-hl7-viewer/src/app/hl7viewer/save-all-confirmation-dialog/save-all-confirmation-dialog.component.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,gBAAA;ACFF;;ADKA;EACE,4BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;ACFF;;ADKA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;ACFF;;ADKA;EACE,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;ACFF;;ADKA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,2CAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;ACFF;;ADKA;EACE,oCAAA;EACA,uBAAA;EACA,qDAAA;EACA,aAAA;EACA,6CAAA;ACFF;;ADKA;EACE,oCAAA;EACA,qCAAA;EACA,qDAAA;EACA,uDAAA;ACFF;;ADMA;EACE,yBAAA;EACA,WAAA;ACHF;;ADMA;EACE,yBAAA;EACA,WAAA;ACHF;;ADMA;EACE,yBAAA;EACA,WAAA;ACHF;;ADMA;EACE,yBAAA;EACA,WAAA;ACHF","sourcesContent":["// Styles for Save All Confirmation Dialog\r\n// Matches application's generic popup styling (xmlMappings/confirm-dialog pattern)\r\n\r\n::ng-deep .mat-dialog-container {\r\n  padding: 0 !important;\r\n  overflow: hidden;\r\n}\r\n\r\nh1.mat-dialog-title {\r\n  padding: 20px 24px 16px 24px;\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  background-color: #f8f9fa;\r\n  text-align: center;\r\n}\r\n\r\n.mat-dialog-content {\r\n  padding: 24px;\r\n  font-size: 12px;\r\n  color: #333;\r\n  max-height: 60vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.mat-dialog-actions {\r\n  padding: 16px 24px;\r\n  margin: 0;\r\n  border-top: 1px solid #e0e0e0;\r\n  background-color: #f8f9fa;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n}\r\n\r\n.Btn_confirm {\r\n  min-width: 80px;\r\n  padding: 6px 16px;\r\n  font-size: 12px;\r\n  border: 1px solid rgba(120, 130, 140, 0.13);\r\n  background-color: #fff;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.Btn_confirm:focus {\r\n  background-color: #ffffff !important;\r\n  color: black !important;\r\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n.Btn_confirm:hover {\r\n  background-color: #f8f9fa !important;\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\r\n  box-shadow: inset 0 -10rem 0px rgba(158, 158, 158, 0.2);\r\n}\r\n\r\n// Badge styles for action labels\r\n.badge-success {\r\n  background-color: #5cb85c;\r\n  color: #fff;\r\n}\r\n\r\n.badge-danger {\r\n  background-color: #d9534f;\r\n  color: #fff;\r\n}\r\n\r\n.badge-warning {\r\n  background-color: #f0ad4e;\r\n  color: #fff;\r\n}\r\n\r\n.badge-secondary {\r\n  background-color: #6c757d;\r\n  color: #fff;\r\n}\r\n\r\n","::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\nh1.mat-dialog-title {\n  padding: 20px 24px 16px 24px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n  text-align: center;\n}\n\n.mat-dialog-content {\n  padding: 24px;\n  font-size: 12px;\n  color: #333;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.mat-dialog-actions {\n  padding: 16px 24px;\n  margin: 0;\n  border-top: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.Btn_confirm {\n  min-width: 80px;\n  padding: 6px 16px;\n  font-size: 12px;\n  border: 1px solid rgba(120, 130, 140, 0.13);\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.87);\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.Btn_confirm:focus {\n  background-color: #ffffff !important;\n  color: black !important;\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.Btn_confirm:hover {\n  background-color: #f8f9fa !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\n  box-shadow: inset 0 -10rem 0px rgba(158, 158, 158, 0.2);\n}\n\n.badge-success {\n  background-color: #5cb85c;\n  color: #fff;\n}\n\n.badge-danger {\n  background-color: #d9534f;\n  color: #fff;\n}\n\n.badge-warning {\n  background-color: #f0ad4e;\n  color: #fff;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
